import type { FieldValueResult } from '@/components/documents/Foxit/FormMapping/composables/FieldValueProvider'
import type { MappedCartItem } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const useFamilyTravelFields = () => {
	const { findCartItems, getFieldPrice, getFieldDescription } =
		useFormFillHelper()

	const transportDesc = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(
				PbProductType.FamilyTravel,
				PbSubcategory.FamilyTravelGeneral
			)

		return [
			{
				name: fieldName,
				value: getFieldDescription(items),
				format: false,
				section: 'cashAdvance',
			},
		]
	}

	const transportPrice = (
		fieldName: string,
		passedItems?: MappedCartItem[]
	): FieldValueResult[] => {
		const items =
			passedItems ??
			findCartItems(
				PbProductType.FamilyTravel,
				PbSubcategory.FamilyTravelGeneral
			)

		return [
			{
				name: fieldName,
				value: getFieldPrice(items),
				format: true,
				section: 'cashAdvance',
				supplementalItems: items,
			},
		]
	}

	const transportFields = (
		fieldNames: Record<string, string>
	): FieldValueResult[] => {
		const items = findCartItems(
			PbProductType.FamilyTravel,
			PbSubcategory.FamilyTravelGeneral
		)

		return [
			...transportDesc(fieldNames.description, items),
			...transportPrice(fieldNames.price, items),
		]
	}

	return {
		transportDesc,
		transportPrice,
		transportFields,
	}
}
